import {
  createRootRouteWithContext,
} from '@tanstack/react-router'
import type { RouterContext } from '@/app/router/router-context'
import { RootComponent } from '@/shared/components/root-component'
import { NotFoundPage } from '@/shared/pages/not-found-page'
import { ApplicationErrorPage } from '@/shared/pages/application-error-page'

export const Route =
  createRootRouteWithContext<RouterContext>()({
    component: RootComponent,
    notFoundComponent: NotFoundPage,
    errorComponent: ApplicationErrorPage,
  })





